import {SET_AUTO_MESSAGE} from '../types';

function actionSetAutoMessage(message)
{
    return {
        type: SET_AUTO_MESSAGE,
        payload: message
    };
}

function actionSetDuration(duration)
{
    return {
        type: SET_MESSAGE_DURATION,
        duration: duration
    };
}

export default actionSetAutoMessage;



// WEBPACK FOOTER //
// ./redux/actions/autoMessage/actionSetAutoMessageText.js